import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import change from '@mailobj-browser/front/js/events/types/change.js'
import playing from '@mailobj-browser/front/js/events/types/playing.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { get } from '#utilities/js/media/stream.js'
import * as utilities from '#utilities/js/styles.js'
import { elements, modifiers } from '../../../styles.js'
import X from '../meet_x.js'
import { scopeProps } from '../props.js'

const deviceTypes = [
  'microphone',
  'camera',
  // 'speaker'
]
const devices = new WeakMap()

const displayVideo = (stream, select) => {
  const { ownerDocument } = select
  const video = one('dialog video', ownerDocument)

  video.srcObject = stream
}

const selectedDevice = object(null, {
  microphone: async () => {
    return await X.getAllAudioInputDevices()
  },
  camera: async ({ selectDevice }) => {
    const { window } = defaults
    const results = await X.getAllVideoInputDevices()
    const current = results.find((d) => d.selected === true)

    if (current) {
      const stream = await get(window, { video: { deviceId: { exact: current.device.deviceId } } })

      if (stream) {
        displayVideo(stream, selectDevice)
      }
    }

    return results
  },
  speaker: async () => {
    return await X.getAllAudioOutputDevices()
  }
})

const deviceInputs = modal => {
  for (const type of deviceTypes) {
    let selectDevice = one(`[name='${type}']`, modal)
    let selectDeviceOption = null
    let selectDeviceList = []

    selectedDevice[type]({ selectDevice }).then((results) => {
        if (!devices.has(selectDevice)) {
          devices.set(selectDevice, results)
        }

        queueMicrotask(async () => {
          await removed(modal)
          if (devices.get(selectDevice) === selectDevice) {
            devices.delete(selectDevice)
          }
        })

        for (const inputDevice of results) {
          selectDeviceOption = one('option', selectDevice).cloneNode(true)
          selectDeviceOption.classList.remove(utilities.modifiers.display.none)

          replaceChildren(selectDeviceOption, inputDevice.device.label)
          selectDeviceOption.value = inputDevice.device.deviceId

          if (inputDevice.selected) {
            selectDeviceOption.selected = true
          }

          selectDeviceList.push(selectDeviceOption)
        }

        if (selectDeviceList.length > 0) {
          replaceChildren(one(`[name='${type}']`, modal), selectDeviceList)
          onChange.listen(selectDevice)
        }
      }
    )
  }
}

const cases = object(null, {
  microphone: ({ device }) => {
    X.setAudioInputDevice(device.device)
  },
  camera: async ({ select, device, constraints }) => {
    const { window } = defaults
    const { ownerDocument } = select
    const video = one('dialog video', ownerDocument)
    let stream

    video.classList.remove(modifiers.meet_device_camera.playing)

    stream = await get(window, { video: constraints })

    if (stream) {
      displayVideo(stream, select)
    }
    X.setVideoInputDevice(device.device)
  },
  speaker: ({ device }) => {
    X.setAudioOutputDevice(device.device)
  },
})

const onChange = object(listener, {
  type: change,
  passive,
  task: (
    select
  ) => {
    const option = select.options[select.selectedIndex]
    const { value } = option
    const list = devices.get(select)
    const device = list.find((d) => d.device.deviceId === value)
    const constraints = { deviceId: { exact: value } }

    cases[select.name]({ select, device, constraints })
  }
})

const onPlaying = object(listener, {
  type: playing,
  passive,
  task: (
    video
  ) => {
    video.classList.add(modifiers.meet_device_camera.playing)
  }
})

const type = 'EA_VIDEOPROPS'
const onVideoProps = object(listener, {
  type,
  passive,
  task: (
    modal,
    event
  ) => {
    const { detail } = event
    const { videoProps = [] } = detail
    const microphoneVisualizer = one(`.${elements.meet_device_microphone_visualizer}`, modal)
    const { myself } = scopeProps()

    for (const { name, talking } of videoProps) {
      // talking status
      if (name === myself && talking) {
        microphoneVisualizer.classList.add(modifiers.meet_device_microphone_visualizer.enabled)
      } else {
        microphoneVisualizer.classList.remove(modifiers.meet_device_microphone_visualizer.enabled)
      }
    }
  }
})

export default async modal => {
  const video = one('video', modal)

  await deviceInputs(modal)

  onPlaying.listen(video)
  onVideoProps.listen(modal)
}
